'use client';
import React, { useEffect, useState } from 'react';

import ListPage from '@/components/page-components/list-page/list-page';
import {
  createListCardArray,
  fetchListingData,
  mergeTenantListItems,
} from '@/helpers/list-page/list-page-helpers';
import { pageIsTenantFoodBeverage } from '@/helpers/list-page/type-guards';
import { getOfferCampaignTagNames } from '@/helpers/get-offer-campaign-tag-names';
import useGetMobileAppWebViewHeader from '@/hooks/use-get-mobile-app-web-view';
import { IMeetingplacePageHomeMinifiedExtendedAttributeFilters } from '@/lib/fragments/meetingPlacePageHome-minified';
import { IMeetingPlacePageTenantFoodBeverageList } from '@/lib/fragments/meetingPlacePageTenantFoodbeverageList';
import { IMeetingPlacePageTenantList } from '@/lib/fragments/meetingPlacePageTenantList';
import {
  useGetActiveOffers,
  useTenantConfig,
} from '@/providers/ConfigProvider';
import { MEETING_PLACE_PAGE_HOME_MINIFIED_EXTENDED_ATTRIBUTE_FILTERS_QUERY } from '@/lib/queries/meetingPlacePageTenantListQuery';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';
// import { PageContext } from '../../../../page-context.interface';

interface MeetingPlacePageTenantFoodbeverageListProps {
  contentfulMeetingPlacePageTenantFoodBeverageList: IMeetingPlacePageTenantFoodBeverageList;
  contentfulMeetingPlacePageTenantList: IMeetingPlacePageTenantList;
  contentfulMeetingPlacePageHome: IMeetingplacePageHomeMinifiedExtendedAttributeFilters;
}
const MeetingPlacePageTenantFoodbeverageList = ({
  metaData,
  node_locale,
  urlSubdirectory,
  tenantListId,
  data,
  initialPage,
}: any) => {
  const config = useTenantConfig();
  const activeOffers = useGetActiveOffers();
  const prefix = config?.GATSBY_SITE_PATH_PREFIX || '';

  const pageId = metaData?.sys?.id;

  const homePageContentfulId =
    config?.MEETINGPLACE_TAG_CONTENTFUL_ID ||
    config?.NEXT_PUBLIC_MEETINGPLACE_TAG_CONTENTFUL_ID;

  const page = data?.meetingPlacePageTenantFoodBevList;
  const homepage = data?.meetingPlacePageHomeCollection;

  let foodBeveragePages = mergeTenantListItems(
    data?.meetingPlacePageTenantList?.tenantsCollection?.items,
    page?.foodBeverageItemsCollection?.items,
    pageIsTenantFoodBeverage,
  );

  console.log('[DEBUG] activeOffers count:', activeOffers?.length);
  console.log(
    '[DEBUG] activeOffers tags sample:',
    activeOffers?.slice(0, 5).map((o: any) => ({
      id: o?.sys?.id,
      tenantId: o?.tenant?.sys?.id,
      tags: getOfferCampaignTagNames(o),
    })),
  );

  foodBeveragePages = foodBeveragePages?.map((item) => {
    const hasOffer = activeOffers?.find(
      (offer: any) => offer?.tenant?.sys?.id == item?.sys?.id,
    );
    console.log(
      `[DEBUG] item: ${item?.name ?? item?.sys?.id}, hasOffer: ${!!hasOffer}, matchingOffers:`,
      activeOffers
        ?.filter((o: any) => o?.tenant?.sys?.id == item?.sys?.id)
        .map((o: any) => ({ tags: getOfferCampaignTagNames(o) })),
    );
    const offerCampaignNames = [
      ...new Set(
        activeOffers
          ?.filter((offer: any) => offer?.tenant?.sys?.id == item?.sys?.id)
          .flatMap((o: any) => getOfferCampaignTagNames(o)),
      ),
    ] as string[];
    return {
      ...item,
      hasOffer: hasOffer ? true : false,
      ...(offerCampaignNames.length > 0 && { offerCampaignNames }),
    };
  });

  const foodBeverageCardList = createListCardArray(
    foodBeveragePages,
    undefined,
    undefined,
    urlSubdirectory,
    node_locale || page?.sys?.locale,
    prefix,
  );

  const isWebView = useGetMobileAppWebViewHeader();

  return (
    <>
      {page && (
        <>
          {/* ✅ GTM PAGE VIEW */}
          <GtmPageView
            homepage={homepage}
            language={node_locale}
            pageTitle={page?.name ?? ''}
          />

          <ListPage
            cardList={foodBeverageCardList}
            pageName={page?.name}
            pageSlug={page?.slug}
            node_locale={node_locale}
            // location={location}
            breadcrumbs={[page?.name]}
            homeText={homepage?.breadcrumbHomeText}
            tileColClass="grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
            listType="food_and_beverage"
            attributeFilters={homepage?.meetingPlace?.attributeFilters}
            isWebView={isWebView}
            config={config}
            initialPage={initialPage ?? 1}
          />
        </>
      )}
    </>
  );
};

export default MeetingPlacePageTenantFoodbeverageList;

